// src/PaginatedTableSimilarWords.js
import React, {useEffect, useState} from 'react';
import './PaginatedTableSubsetWords.css';
import { Table, Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import chroma from 'chroma-js';
import Popup from "reactjs-popup";
import axios from "axios";
import {SERVER_URL, SIMILAR_WORDS} from "../../../services/Config";
// const data = [
//     { sentence: 'This is the first sentence.', value: 1 },
//     { sentence: 'This is the second sentence.', value: 2 },
//     { sentence: 'This is the third sentence.', value: 3 },
//     // Add more sentences as needed...
//     { sentence: 'This is the eleventh sentence.', value: 11 },
//     { sentence: 'This is the twelfth sentence.', value: 12 },
//     // Ensure you have more than 10 sentences for pagination
// ];

// data is a list of lists of word
const PaginatedTableSubsetWords = ({ data, rowsPerPage, resetPage }) => {
    const [currentPage, setCurrentPage] = useState(1);

    const [show, setShow] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalTitle, setModalTitle] = useState('');

    const handleClose = () => {
        setModalTitle('')
        setModalContent('')
        setShow(false)
    };

    const [pageData, setPageData] = useState(data);

    const stripPfamId = (input) => {
        // Use regex to strip out the part in parentheses
        return input.replace(/\s*\(.*?\)\s*/g, '');
    };

    const renderDescription = (desc, literature) => {
        return desc.replace(/\[\[cite:(PUB\d+)\]\]/g, (match, p1) => {
            const lit = literature[p1];
            if (lit) {
                // return `<a href="${lit.DOI_URL}" target="_blank" rel="noopener noreferrer" class="blue-underline">
                //   ${lit.title}
                // </a>`;
                return `<a href="${lit.DOI_URL}" target="_blank" rel="noopener noreferrer" class="blue-underline">
                  [publication link]
                </a>`;
            }
            return match;
        });
    };

    const handleShow = (content) => {
        setModalTitle('Loading....')

        const pfamId = stripPfamId(content)
        axios
            .get(`https://www.ebi.ac.uk/interpro/api/entry/pfam/${pfamId}`)
            .then((response) => {
                console.log('get response')


                const curMetaData = response.data.metadata
                let description = curMetaData.description[0].text
                const literature = curMetaData.literature
                if(literature){
                    description = renderDescription(description,literature)
                }

                // console.log(description,literature)
                setModalTitle(content)
                setModalContent(description)

            })
            .catch((e) => {
                console.log('intepro id error')
                console.log(e.response)

                setModalTitle(content)
                setModalTitle('No description found')



            });

        // setModalContent(content);
        setShow(true);
    };



    const totalPages = Math.ceil(data.length / rowsPerPage);

    const handleClick = (page) => {
        // pageData = data[]
        // const slicedData = data.slice(page*rowsPerPage, page*(rowsPerPage+1));
        // setPageData(slicedData)
        setCurrentPage(page);
    };

    const currentData = data.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );



    useEffect(()=>{
        setCurrentPage(1)
    },[resetPage])


    // Function to generate a color based on the text
    const stringToColor = (str) => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        const hue = hash % 360; // Use the hash to determine the hue
        const color = chroma.hsl(hue, 0.6, 0.6).alpha(0.7).css(); // Generate color with 70% saturation and 50% lightness with 50% opacity
        return color;
    };

    return (
        <div>
            <table className="table">
                <thead>
                <tr>
                    <th>Proteins that contains target domain(s)</th>
                    {/*<th>Search for current combination </th>*/}
                    {/*<th>Search</th>*/}
                </tr>
                </thead>
                <tbody>
                {currentData.map((list, rowIndex) => (
                    <tr key={rowIndex}>
                        <td>
                            <div className="sentence-divider">
                                {list.map((item, itemIndex) => (
                                    <span
                                        key={itemIndex}
                                        className="clickable-word"
                                        // data-text={item}
                                        style={{ backgroundColor: stringToColor(item) }}
                                        onClick={() => handleShow(item)}
                                    >
                                {item}
                                        {itemIndex < list.length - 1 && ' '}
                                </span>
                                ))}
                            </div>
                        </td>
                        {/*<td>*/}
                        {/*    <button*/}
                        {/*        onClick={() => alertFirstColumnText(list)}*/}
                        {/*    >*/}
                        {/*        Details*/}
                        {/*    </button>*/}
                        {/*</td>*/}

                    </tr>

                ))}
                </tbody>



            </table>
            <div className="pagination">
                {Array.from({ length: totalPages }, (_, index) => (
                    <button
                        key={index}
                        onClick={() => handleClick(index + 1)}
                        className={currentPage === index + 1 ? 'active' : ''}
                    >
                        {index + 1}
                    </button>
                ))}
            </div>


            <Popup
                open={show}
                onClose={handleClose}
                modal
                closeOnDocumentClick
                nested
                // contentStyle={{ padding: '20px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', maxHeight: '80vh', overflowY: 'auto' }}
            >
                <div className="modal">
                    <a className="close" onClick={handleClose}>
                        &times;
                    </a>


                    <div className="metadata-container">
                        <h4>{modalTitle}</h4>
                        <div className="description-container" dangerouslySetInnerHTML={{ __html: modalContent }} />
                    </div>


                    {/*<div dangerouslySetInnerHTML={{ __html: modalContent }}></div>*/}

                </div>
            </Popup>

        </div>


    );
};

export default PaginatedTableSubsetWords;
